var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLudzieFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171:20153)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DED0BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1971 42.0205C47.0797 37.6478 36.9423 43.685 36.7507 52.2685C36.4518 65.6005 57.6191 70.6709 61.9615 58.9298",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3128 40.3433C59.3717 32.2185 47.9349 29.3193 41.7297 35.2533C32.0916 44.469 43.4738 63.0226 54.8465 57.7903",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5277 44.1936C71.9004 37.0762 65.8632 26.9389 57.2797 26.7473C43.9476 26.4484 38.8773 47.6157 50.6184 51.9581",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2002 51.306C77.3249 49.3649 80.2241 37.9281 74.2901 31.7229C65.0744 22.0848 46.5209 33.467 51.7532 44.8397",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3513 57.5207C72.4687 61.8935 82.6061 55.8563 82.7977 47.2727C83.0966 33.9407 61.9293 28.8703 57.5869 40.6114",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2363 59.1935C60.1774 67.3182 71.6143 70.2174 77.8195 64.2834C87.4575 55.0677 76.0754 36.5142 64.7026 41.7464",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0238 55.3515C47.6511 62.4689 53.6883 72.6062 62.2718 72.7978C75.6038 73.0967 80.6742 51.9294 68.9331 47.587",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.35 48.2363C42.2252 50.1774 39.3261 61.6143 45.26 67.8195C54.4758 77.4575 73.0293 66.0754 67.797 54.7026",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9619 46.3597C49.2117 44.9233 46.2815 44.5542 43.7095 46.3111C41.0917 48.0984 39.8955 51.8355 42.0842 54.2739",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9565 41.1226C55.7346 38.8691 53.9244 36.5366 50.8632 35.9598C47.7475 35.3728 44.2593 37.1695 44.0825 40.4411",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1906 40.9585C64.627 39.2083 64.9961 36.2781 63.2392 33.7061C61.4519 31.0883 57.7147 29.892 55.2764 32.0808",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4219 45.9532C70.6754 45.7313 73.0078 43.9211 73.5847 40.8599C74.1717 37.7442 72.3749 34.256 69.1033 34.0792",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5859 53.1837C70.3361 54.6202 73.2663 54.9892 75.8383 53.2323C78.4561 51.4451 79.6523 47.7079 77.4636 45.2695",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5923 58.4152C63.8143 60.6687 65.6245 63.0011 68.6856 63.578C71.8013 64.1649 75.2895 62.3682 75.4663 59.0966",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3597 58.5859C54.9233 60.3361 54.5542 63.2663 56.3111 65.8383C58.0984 68.4561 61.8355 69.6523 64.2739 67.4636",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1294 53.5887C48.8759 53.8107 46.5435 55.6209 45.9666 58.682C45.3796 61.7978 47.1763 65.286 50.448 65.4628",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4989 40.3827C65.6819 40.7831 69.559 45.3096 69.1586 50.4931C68.7582 55.6765 64.2319 59.5539 59.0488 59.1536C53.8658 58.7532 49.9887 54.2266 50.3891 49.0431C50.7895 43.8597 55.3158 39.9823 60.4989 40.3827Z",
    stroke: "#4F5F6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 11.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171:20153",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.815686 0 0 0 0 0.737255 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171:20153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171:20153",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudzieFilled);
export default __webpack_public_path__ + "static/media/ludzie_filled.aae087f7.svg";
export { ForwardRef as ReactComponent };